import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SaveButton from "src/components/pages/Organize/SaveButton";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { Button } from "src/components/shared/Button/Button";
import ConfirmationButton from "src/components/shared/ConfirmationButton/ConfirmationButton";
import GroupsList from "src/components/shared/Grouping/GroupList/GroupsList";
import LogbooksSelector from "src/components/shared/Grouping/LogbooksSelector/LogbooksSelector";
import Loader from "src/components/shared/Loader/Loader";
import { useGetApi, usePostApi } from "src/hooks";
import { useDispatch, useSelector } from "src/redux/hooks";
import {
  addElement,
  moveLogbook,
  removeElement,
  setInitialData,
  setSelectedGroup,
  setValue,
} from "src/redux/slices/organizeSlice";
import { ButtonsWrapper, Flex, PageContainer } from "src/styled";

import {
  GroupProvider,
  type IGroupContext,
} from "../../../../components/shared/Grouping/GroupContext";
import { type ILogbook } from "../../../../interfaces";
import { mapOrganize } from "../../../Organize/Organize.utils";

const Organize = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { post, isLoading: isPostLoading } = usePostApi();

  const { labels, selectedLabel } = useSelector(state => state.organizeSlice);

  const { data } = useGetApi({
    request: "get-meta",
    body: {
      params: { type: "label" },
    },
  });
  const { data: logbooksData } = useGetApi({
    request: "get-home",
    mapper: mapOrganize,
  });
  useEffect(() => {
    if (data && logbooksData) {
      const preparedData = {
        logbooks: logbooksData.logbooks,
        labels: [],
      };
      dispatch(setInitialData(preparedData));
    }
  }, [data, logbooksData]);

  const handleReset = async () => {
    // await post({ request: "save-home-groups", body: { params: [] } });
    // navigate("/home");
  };

  const handleAddElement = () =>
    dispatch(addElement({ keyForData: "labels", defaultName: "New Label" }));

  const context: IGroupContext = {
    selectedElement: selectedLabel,
    handleAddElement,
    handleReset,
    handleEditElement: (data: any) =>
      dispatch(setValue({ ...data, keyForData: "labels" })),
    handleDeleteElement: (groupId: any) =>
      dispatch(removeElement({ id: groupId, keyForData: "labels" })),
    handleSelectElement: (group: any) => dispatch(setSelectedGroup(group)),
    handleMoveLogbook: (logbook: ILogbook) =>
      dispatch(moveLogbook({ logbook, keyForData: "labels" })),
    elementsSection: {
      title: "Labels",
      emptyMessage: "No labels yet",
    },
    addButtonLabel: "Add Label +",
  };
  const isLoading = false;
  const handleSave = async () => {
    const requests = labels
      .filter(el => el.changed)
      .map(async label => {
        const tag = label.logbooks
          .map((logbook: any) => logbook.lbid)
          .join("__");
        return await post({
          request: "set-meta",
          body: { params: { type: "label", data: { ...label }, tag } },
        });
      });
    const res = await Promise.all(requests);
  };
  return (
    <GroupProvider context={context}>
      <PageContainer>
        <Breadcrumbs>
          <ButtonsWrapper>
            <ConfirmationButton
              modalText="Are you sure you want to reset, current labels will be removed."
              onConfirm={handleReset}>
              Reset
            </ConfirmationButton>
            <Button onClick={handleAddElement}>{context.addButtonLabel}</Button>
            <SaveButton handleSave={handleSave} isLoading={isPostLoading} />
          </ButtonsWrapper>
        </Breadcrumbs>
        {isLoading ? (
          <Loader />
        ) : (
          <Flex mt={30}>
            <GroupsList elements={labels.filter(el => el.active === 1)} />
            <LogbooksSelector />
          </Flex>
        )}
      </PageContainer>
    </GroupProvider>
  );
};

export default Organize;
